import InnerContainer from "@components/_Revamp/InnerContainer";

export default InnerContainer